import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
    namespaced: true,
    state: {
        usersPublic: []
    },
    getters: {
        getUsersPublic: state => state.usersPublic
    },
    mutations: {
        SET_USERS_PUBLIC(state, users) {
            state.usersPublic = users;
        }
    },
    actions: {
        async loadUsersPublic({commit}) {
            const snapshot = await firebase.firestore().collection(process.env.VUE_APP_COLLECTION_USERS).get();
            const usersPublic = snapshot.docs.map(doc => doc.data());
            commit('SET_USERS_PUBLIC', usersPublic);
        }
    }
}
